import { Injectable } from '@angular/core';
import { DateUtility } from './utilities/date.service';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  constructor(
  ) {
  }

  buildUrlWithParams(baseUrl: string, jsonParams: any) {
    if (baseUrl && jsonParams) {
      try {
        let params = [];
        Object.keys(jsonParams).forEach(key => {
          params.push([key, jsonParams[key]].join("="));
        });
        return `${baseUrl.includes('?') ? baseUrl : baseUrl + '?'}${params.join("&")}`;
      } catch (error) {
        return '';
      }
    }
    return '';
  }
}
